"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalContainer = exports.Title = exports.SessionListStyled = exports.Overlay = exports.ImageButton = exports.Image = exports.HorizontalContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = require("../../../atoms/Typography");
const Overlay = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;
exports.Overlay = Overlay;
const ImageButton = styled_components_1.default.button `
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.625rem;
`;
exports.ImageButton = ImageButton;
const Image = styled_components_1.default.img `
  width: 2rem;
  height: 2rem;
`;
exports.Image = Image;
const Title = (0, styled_components_1.default)(Typography_1.H4) `
  text-align: left;
  font-weight: 400;
  font-size: 1.8rem;
`;
exports.Title = Title;
const HorizontalContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  left: 0;
  align-items: center;
  padding: 0.5rem 1rem 2rem 1.5rem;
  gap: 1rem;
`;
exports.HorizontalContainer = HorizontalContainer;
const VerticalContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 1.25rem;
  max-height: 100%;
  padding-bottom: 2rem;
`;
exports.VerticalContainer = VerticalContainer;
const SessionListStyled = styled_components_1.default.div `
  width: 100%;
  overflow-y: auto;
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
exports.SessionListStyled = SessionListStyled;
